import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useParams } from "@/components/hooks/use-params";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Divider } from "@/components/shared/divider";
import { ListHeading } from "@/components/shared/list-header";
import { Redirect, useRoute } from "@/components/shared/router";
import { ScrollContent } from "@/components/shared/scroll-content";
import { View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { getPlatform } from "@/lib/utils";

import { SectionGiftCardForm } from "./section-gift-card-form";
import { SectionGiftCardNavigationBottom } from "./section-gift-card-navigation-bottom";
import { SectionGiftCardOrder } from "./section-gift-card-order";
import { SectionGiftCardPreview } from "./section-gift-card-preview";
import { useGiftCardForm } from "./use-gift-card-form";

export function GiftCardNewPage() {
  const { pull } = useRoute();
  const { isMobile } = useWindowDimensions();
  const { top } = useSafeAreaInsets();
  const isWeb = getPlatform() === "web";
  const formReturn = useGiftCardForm();
  const { key } = useParams<{ key?: string }>();

  useEffect(() => {
    if (key && key !== formReturn.getValues("occasion")) {
      formReturn.setValue("occasion", key, { shouldValidate: false });
    }
  }, [key]);

  if (!key) {
    return <Redirect path="/profile/gift-card/new?key=gift-for-you" />;
  }

  const handleBack = () => {
    pull();
  };

  return (
    <FormProvider {...formReturn}>
      <ScrollContent withPaddingTop={false} FooterComponent={<SectionGiftCardNavigationBottom />}>
        <View style={{ paddingTop: top }} className="web:mb-32 md:mb-0">
          <View className="flex flex-row">
            {/* min-w-0 for stabilize the x coordinate width. 
            somehow our HorizontalScroll goes thru the parent 
            and cannot be setted as an overflow */}
            <View className="flex min-w-0 flex-col">
              <View className="flex flex-col gap-0 p-4 md:pt-0">
                <View className="flex flex-row items-center justify-between">
                  <View className="flex flex-row items-center gap-4">
                    <IconButton
                      variant={isMobile ? "ghost" : "secondary"}
                      color="foreground"
                      iconName="arrowLeft"
                      rounded="full"
                      onClick={handleBack}
                    />
                    <ListHeading title="Send Gift Card" />
                  </View>
                </View>
              </View>
              <Divider className="md:mx-4" />
              <View className="border-border md:mx-4 md:mt-6 md:rounded-lg md:border">
                <SectionGiftCardPreview />
                <SectionGiftCardForm />
              </View>
            </View>
            {!isMobile && <SectionGiftCardOrder />}
          </View>
        </View>
      </ScrollContent>
      {isWeb && (
        <View className="fixed bottom-0 left-0 z-20 w-full">
          <SectionGiftCardNavigationBottom />
        </View>
      )}
    </FormProvider>
  );
}
